import { Avatar } from "@mui/material";
import moment from "moment-timezone";
import React, { useEffect, useRef, useState } from "react";
import Loading from "../../Component/Loading";
import { Modal } from "react-bootstrap";
import { AiOutlineSearch } from "react-icons/ai";
import useAppointmentDetails from "./Hooks/useAppointmentDetails";
import RescheduleAppointment from "./Component/RescheduleAppointment";
import CancelAppointment from "./Component/CancelAppointment";
import { IoMdAdd } from "react-icons/io";
import { AppointmentStatus } from "../../Context/constants";
import { FaArrowLeft } from 'react-icons/fa';
import { Dosage } from "../../Utils/Utils";
import { NoRecordFound } from "../../Component/NoRecordFound";
import { clinicPictures, SignatureURL } from "../../Context/api";
import TextBox from "../../Component/TextBox";
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, XAxis, YAxis, Tooltip } from "recharts";
const AppointmentDetails = () => {
    const {
        setValue,
        reschedulefun,
        setModalCancel,
        handlePrint,
        setAddpatientModal,
        deletePatientfun,
        setAddPatientValue,
        setDeletePatientdata,
        setDeletePatientmodal,
        addpatientfun,
        setIsactiveSlot,
        setTap,
        clossOffcanvas,
        getlistPatient,
        navigate,
        base64Image,
        CustomButton,
        tap,
        loader,
        apptDetails,
        userdata,
        componentRef,
        checkoutSlipData,
        isMaxPatients,
        ePrescriptionList,
        deletePatientmodal,
        addpatientModal,
        allpatientList,
        patientDetails,
        deletePatientdata,
        AddPatientValue,
        modalCancel,
        cancelAppointment,
        modalReschdule,
        appointmentReschedule,
        TimeslotList,
        SlotLodaer,
        isActiveSlot,
        checkoutSlipGraphData,
        checkoutCount,
    } = useAppointmentDetails()
    const [shouldBreakPage, setShouldBreakPage] = useState(false);
    const pageLength = useRef()
    const { insightsPatientTemp = [], insightsPatientBp = [], insightsPatientBMI = [] } = checkoutSlipGraphData || {}
    const doctorDegrees = checkoutSlipData?.doctorDegrees?.map((item, index) => <span key={index} >{item?.degree}{checkoutSlipData?.doctorDegrees?.length > index + 1 ? ', ' : ''}</span>)
    const doctorName = `${checkoutSlipData?.doctorTitle ?? "-"} ${checkoutSlipData?.doctorFirstName ?? "-"} ${checkoutSlipData?.doctorLastName ?? "-"}`

    const fullFirstAddress1 = [
        checkoutSlipData?.street

    ].filter(Boolean).join(", ");
    const fullFirstAddress = [
        checkoutSlipData?.address,

    ].filter(Boolean).join(", ");
    const fullLastAddress = [
        checkoutSlipData?.city,
        checkoutSlipData?.state,
        checkoutSlipData?.country,
        checkoutSlipData?.zipCode
    ].filter(Boolean).join(", ");

    const fullPatientAddress = [
        checkoutSlipData?.patientCity,
        checkoutSlipData?.patientState,
    ].filter(Boolean).join(", ");

    useEffect(() => {
        if (pageLength.current) {
            const height = pageLength.current.offsetHeight;
            console.log(height, "height")
            if (height > 700) setShouldBreakPage(true);
        }
    }, [])
    return <>
        {loader && <Loading />}
        <div className="common-component-box">
            <header className="body_header" >
                <div className="d-flex justify-content-start align-items-center ">
                    <FaArrowLeft className="me-2 cursor" onClick={() => { navigate(-1) }} />
                    <h2 className="page_name">Details</h2>
                </div>
            </header>
            <div className="common-white-bg-box mx-0 shadow">
                <div className="row px-0 mx-0">
                    <div className="col-12">
                        <div className="tab_scroll">
                            <ul className="nav  mb-0" style={{ width: "500px" }}>
                                <li className="nav-item" role="presentation">
                                    <button className={`teams_frofile_stepper_btn me-2 ${tap === 1 && "active_teams_frofile"}`} id="personal" type="button" onClick={() => setTap(1)} >Appointment Details</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className={`teams_frofile_stepper_btn ${tap === 2 && "active_teams_frofile"}`} id="education" type="button" onClick={() => setTap(2)} >Patient Details</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className={`teams_frofile_stepper_btn ${tap === 3 && "active_teams_frofile"}`} id="education" type="button" onClick={() => setTap(3)} >E-prescription</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className={`teams_frofile_stepper_btn ${tap === 4 && "active_teams_frofile"}`} id="education" type="button" onClick={() => setTap(4)} >Checkout Slip</button>
                                </li>
                            </ul>
                        </div>
                        {
                            tap === 1 && <div className="p-0">
                                <div className="row position-relative text_box_height align-content-start px-2 " >
                                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>

                                        <div className="row">
                                            <div className="col-lg-7">
                                                <div className="row">
                                                    <div className="col-lg-5">
                                                        <label className="form-label mb-0">Appointment Number</label>
                                                    </div>
                                                    <div className="col-lg-7">
                                                        <TextBox textBoxData={<p>{apptDetails?.appointmentNumber}</p>} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-5">
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-7">
                                                <div className="row">
                                                    <div className="col-lg-5">

                                                    </div>
                                                    <div className="col-lg-7">

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-5">
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>

                                        <div className="row">
                                            <div className="col-lg-7">
                                                <div className="row">
                                                    <div className="col-lg-5">
                                                        <label className="form-label mb-0">Clinic</label>
                                                    </div>
                                                    <div className="col-lg-7">
                                                        <TextBox textBoxData={<p>{apptDetails?.clinicName}</p>} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-5">
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                                        <div className="row">
                                            <div className="col-lg-7">
                                                <div className="row">
                                                    <div className="col-lg-5">
                                                        <label className="form-label mb-0">Appointment Date</label>
                                                    </div>
                                                    <div className="col-lg-7">
                                                        <TextBox textBoxData={<p>{`${moment(apptDetails?.startDate)?.tz(userdata?.timezoneName)?.format('YYYY-MM-DD')}`}</p>} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-5">
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                                        <div className="row">
                                            <div className="col-lg-7">
                                                <div className="row">
                                                    <div className="col-lg-5">
                                                        <label className="form-label mb-0">Patient Name</label>
                                                    </div>
                                                    <div className="col-lg-7">
                                                        <TextBox textBoxData={<p>{(apptDetails?.patientFirstName ? apptDetails?.patientFirstName : "") + " " + (apptDetails?.patientLastName ? apptDetails?.patientLastName : '')}</p>} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-5">
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                                        <div className="row">
                                            <div className="col-lg-7">
                                                <div className="row">
                                                    <div className="col-lg-5">
                                                        <label className="form-label mb-0">Appointment Time</label>
                                                    </div>
                                                    <div className="col-lg-7">
                                                        <TextBox textBoxData={<p>{`${moment(apptDetails?.startDate)?.tz(userdata?.timezoneName)?.format("hh:mm A")}   -  ${moment(apptDetails?.endDate)?.tz(userdata?.timezoneName)?.format("hh:mm A")}`}</p>} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-5">
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                                        <div className="row">
                                            <div className="col-lg-7">
                                                <div className="row">
                                                    <div className="col-lg-5">
                                                        <label className="form-label mb-0">Status</label>
                                                    </div>
                                                    <div className="col-lg-7">
                                                        <TextBox textBoxData={<p>{apptDetails?.Status}</p>} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-5">
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        apptDetails?.Status === AppointmentStatus?.CANCELLED && <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                                            <div className="row">
                                                <div className="col-lg-7">
                                                    <div className="row">
                                                        <div className="col-lg-5">
                                                            <label className="form-label mb-0">Cancelled Reason</label>
                                                        </div>
                                                        <div className="col-lg-7">
                                                            <TextBox textBoxData={<p>{apptDetails?.cancellationReason}</p>} />

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-5">
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                                        <div className="row">
                                            <div className="col-lg-7">
                                                <div className="row">
                                                    <div className="col-lg-5">
                                                        <label className="form-label mb-0">Specialization</label>
                                                    </div>
                                                    <div className="col-lg-7">
                                                        <TextBox textBoxData={<p>{apptDetails?.specialisationName}</p>} />

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-5">
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                                        <div className="row">
                                            <div className="col-lg-7">
                                                <div className="row">
                                                    <div className="col-lg-5">
                                                        <label className="form-label mb-0">Service</label>
                                                    </div>
                                                    <div className="col-lg-7">
                                                        <TextBox textBoxData={<p>{apptDetails?.serviceName}</p>} />

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-5">
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                                        <div className="row">
                                            <div className="col-lg-7">
                                                <div className="row">
                                                    <div className="col-lg-5">
                                                        <label className="form-label mb-0">Doctor</label>
                                                    </div>
                                                    <div className="col-lg-7">
                                                        <TextBox textBoxData={<p>{(apptDetails?.doctorFirstName && apptDetails?.doctorLastName) ? apptDetails?.doctorFirstName + ' ' + apptDetails?.doctorLastName : null}</p>} />

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-5">
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                                        <div className="row">
                                            <div className="col-lg-7">
                                                <div className="row">
                                                    <div className="col-lg-5">
                                                        <label className="form-label mb-0">Final Price</label>
                                                    </div>
                                                    <div className="col-lg-7">
                                                        <TextBox textBoxData={<p>{(apptDetails?.finalPrice) ? `${apptDetails?.currencyImage}${apptDetails?.finalPrice}` : ""}</p>} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-5">
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 d-grid justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-end justify-content-xl-end justify-content-xxl-end my-3 px-0" >
                                        <div className="d-flex">
                                            {!(apptDetails?.Status === AppointmentStatus.CANCELLED || apptDetails?.Status === AppointmentStatus?.RESCHEDULED || apptDetails?.Status === AppointmentStatus.CHECKEDOUT) && <CustomButton variant="contained" onClick={reschedulefun} className="me-3" >Reschedule Appointment</CustomButton>}
                                            {!(apptDetails?.Status === AppointmentStatus.CANCELLED || apptDetails?.Status === AppointmentStatus.CHECKEDOUT) && <CustomButton variant="contained" onClick={() => setModalCancel((apptDetails?.Status === AppointmentStatus.CANCELLED || apptDetails?.Status === AppointmentStatus.CHECKEDOUT) ? false : true)} >Cancel Appointment</CustomButton>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            tap === 2 && <div className='p-0 pt-3 text_box_height'  >
                                <div className="mx-0 px-0 row d-flex justify-content-end mb-2">
                                    <div className=" mx-0 px-2 col-6 d-flex justify-content-end">
                                        <CustomButton variant="contained" disabled={(apptDetails?.Status === AppointmentStatus.CANCELLED || apptDetails?.Status === AppointmentStatus.CHECKEDOUT) ? true : isMaxPatients ? true : false}
                                            onClick={() => { getlistPatient(); setAddpatientModal(true) }}
                                            startIcon={<IoMdAdd />}
                                        >add patient</CustomButton>
                                    </div>
                                </div>
                                <div className="row px-2 g-3">
                                    {
                                        !patientDetails.length && <h3 className='text-center mt-5' style={{ color: "gray", fontSize: "12px" }}>No record found  </h3>
                                    }
                                    {patientDetails?.map((cur, index) => {
                                        return <div className="col-lg-4 col-xl-3 col-md-6 col-12" key={cur?.patientId}>
                                            <div className="col shadow PATIENT-CARD rounded">
                                                <div className="w-25">
                                                    <Avatar alt="Remy Sharp" sx={{ width: 50, height: 50 }} />
                                                </div>
                                                <div className="w-50 TEXT-CONTENT">
                                                    <p>{(cur?.patientFirstName ? cur?.patientFirstName : "") + " " + (cur?.patientLastName ? cur?.patientLastName : '')}</p>
                                                    <p>{cur?.email}</p>
                                                </div>
                                                <div className="w-25 text-end">
                                                    <i
                                                        onClick={() => { setDeletePatientmodal(true); setDeletePatientdata(cur) }}
                                                        style={{ cursor: "pointer" }}
                                                        className="fa-solid fa-trash-can ms-3 fs-6 all_icons_color" ></i>
                                                </div>
                                            </div>
                                        </div>
                                    })}

                                </div>
                            </div>
                        }
                        {
                            tap === 4 && <div className='p-0 pt-2 text_box_height' >
                                {
                                    apptDetails?.Status !== AppointmentStatus.CHECKEDOUT ? <div className="col-sm-12 mt-3 text-center " > <NoRecordFound /></div> :
                                        <div className="row px-0 mx-0 px-5">
                                            <div className="col-3 ms-auto d-flex justify-content-end pe-0 mb-2">
                                                <CustomButton
                                                    onClick={handlePrint}
                                                    variant="contained" >print</CustomButton>
                                            </div>
                                            <div className=" w-100 bg p-0 checkout_clip_container  bgimg " ref={componentRef}>
                                                <div ref={pageLength}>
                                                    <div className=" d-flex  justify-content-between w-100 ">
                                                        <div className="d-flex justify-content-between flex-column">
                                                            <div className="">
                                                                <h4 >{doctorName}</h4>
                                                                <h5 className="mb-1" ><span>{doctorDegrees}</span> | Reg No:{checkoutSlipData?.regNo ?? "N/A"} |</h5>
                                                                <h5 className="mb-1" >Mob. No. {checkoutSlipData?.doctorMobile ?? "N/A"}</h5>
                                                            </div>
                                                            <div className=" mt-3">
                                                                <h5 className="mb-1"><b>P. ID: {checkoutSlipData?.patientId ?? ""} - {(checkoutSlipData?.patientFirstName ?? "") + " " + (checkoutSlipData?.patientLastName ?? "")}</b></h5>
                                                                <h5 className="mb-1">Address: {fullPatientAddress}</h5>
                                                                <h5 className="mb-1">Temp: <b>{checkoutSlipData?.temperature ?? "N/A"}<sup>&#176;</sup>F</b>, BP: <b>{checkoutSlipData?.bp ?? "N/A"}</b>, Pulse: <b>{checkoutSlipData?.pulse ?? "N/A"} BPM.</b></h5>
                                                            </div>

                                                        </div>
                                                        <div className=" ">
                                                            <div className="text-start" >
                                                                <div className="d-flex align-items-center mb-1">
                                                                    <img
                                                                        src={base64Image?.clinicImage}
                                                                        alt={checkoutSlipData?.clinicName ?? ""}
                                                                        style={{ width: 40, height: 40, borderRadius: "50%", objectFit: "cover" }}
                                                                    />
                                                                    <h4 className="mb-0 ms-2">{checkoutSlipData?.clinicName ?? "N/A"}</h4>
                                                                </div>
                                                                <h5 className="mb-1">{fullFirstAddress1}</h5>
                                                                <h5 className="mb-1">{fullFirstAddress}</h5>
                                                                <h5 className="mb-1">{fullLastAddress}</h5>
                                                            </div>
                                                            <div className="  d-flex   flex-column mt-3">
                                                                <div className="d-flex justify-content-end">
                                                                    <div dangerouslySetInnerHTML={{ __html: checkoutSlipData?.barcode }} />

                                                                </div>
                                                                <div className=" mt-2">
                                                                    <h5 className="mb-1"><b>Date: {moment(checkoutSlipData?.apptStartDate).format("DD-MMM-YYYY")}, {moment(checkoutSlipData?.apptStartDate).format("hh:mm A")}</b></h5>
                                                                    <h5 className="mb-1">Height: <b>{checkoutSlipData?.height ?? "N/A"} cm</b>, Weight: <b>{checkoutSlipData?.weight ?? "N/A"} kg</b> </h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className=" patient_details  d-flex align-items-end justify-content-between mt-md-0 mt-3">
                                                    </div>
                                                    <hr className="hr my-2" />
                                                    <div className="d-flex justify-content-start align-items-center my-2">
                                                        <img src={require("../../Assets/UploadDocumentImage/Doctor.png")} className="icone  me-3" alt="" />
                                                        <h5 className="mb-0">
                                                            <b>Symptoms:</b>{" "}
                                                            {checkoutSlipData?.symptom?.length > 0
                                                                ? checkoutSlipData.symptom.map((item, index) => (
                                                                    <span key={index}>
                                                                        {item?.symptoms}
                                                                        {checkoutSlipData.symptom.length > index + 1 ? ", " : ""}
                                                                    </span>
                                                                ))
                                                                : "N/A"}
                                                        </h5>
                                                    </div>
                                                    <hr className="hr my-2" />
                                                    {
                                                        checkoutSlipData?.rx?.length > 0 && <>
                                                            <div className="my-2">
                                                                <img src={require("../../Assets/UploadDocumentImage/prescription.png")} className="icone  " alt="" />
                                                                <table class="table table-bordered ">
                                                                    <thead>
                                                                        <tr>
                                                                            <th style={{ backgroundColor: "transparent" }} scope="col"></th>
                                                                            <th style={{ backgroundColor: "transparent" }} scope="col">Medicine Name</th>
                                                                            <th className="text-center" style={{ backgroundColor: "transparent" }} scope="col">Dosage</th>
                                                                            <th className="text-center" style={{ backgroundColor: "transparent" }} scope="col">Duration</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            checkoutSlipData?.rx?.map((cur, index) => {
                                                                                return <tr>
                                                                                    <td >{index + 1}</td>
                                                                                    <td >{`${cur?.medicineType ?? ""}, ${cur?.medicineName ?? ""}, ${cur?.doseAmount ?? ""}${cur?.doseType ?? ""}`}</td>
                                                                                    <td className="text-center">
                                                                                        {Dosage(cur)} <br />
                                                                                        ({cur?.medicineIntakeTime !== "CUSTOM" ? cur?.medicineIntakeTime : cur?.medicineIntakeCustomTime})
                                                                                    </td>
                                                                                    <td className="text-center">{cur?.medicineIntakeDurationAmount + " " + cur?.medicineIntakeDurationType}
                                                                                        <br />
                                                                                        {`(Tot: ${cur?.totalTablets} ${cur?.tabletType})`}
                                                                                    </td>
                                                                                </tr>
                                                                            })
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <hr className="hr my-2" />
                                                        </>
                                                    }
                                                    <div className="d-flex  justify-content-start align-items-center my-2">
                                                        <img src={require("../../Assets/UploadDocumentImage/blood-sample.png")} className="icone  me-3" alt="" />
                                                        <h5 className="mb-0">
                                                            <b>Test Required: </b>
                                                            {checkoutSlipData?.tests?.length > 0
                                                                ? checkoutSlipData.tests.map((item, index) => (
                                                                    <span key={index}>
                                                                        {item?.testsName}
                                                                        {checkoutSlipData.tests.length > index + 1 ? ", " : ""}
                                                                    </span>
                                                                ))
                                                                : "N/A"}
                                                        </h5>
                                                    </div>
                                                    <hr className="hr my-2" />
                                                    <div className="d-flex  justify-content-start align-items-center ">
                                                        <h5 className="mb-0">
                                                            <b>Notes: </b>
                                                            {
                                                                [...new Set(checkoutSlipData?.rx?.map(cur => cur?.notes).filter(Boolean))]?.length > 0
                                                                    ? [...new Set(checkoutSlipData.rx.map(cur => cur?.notes).filter(Boolean))].map((item, index, array) => (
                                                                        <span key={index}>
                                                                            {item}
                                                                            {array.length > index + 1 ? ", " : ""}
                                                                        </span>
                                                                    ))
                                                                    : "N/A"
                                                            }
                                                        </h5>
                                                    </div>
                                                    <hr className="hr my-2" />
                                                    <div className="d-flex  justify-content-start align-items-center ">
                                                        <h5 className="mb-0"><b>Follow-Up: </b>{checkoutSlipData?.followUpDate ? moment(checkoutSlipData?.followUpDate)?.format("DD/MM/YYYY") : "N/A"} </h5>
                                                    </div>
                                                    <hr className="hr my-2" />
                                                </div>
                                                {
                                                    checkoutCount > 1 && <>
                                                        {shouldBreakPage && <div className="page-break-before"></div>}
                                                        <div className="">
                                                            <h5 className="mb-0"><b>Charts</b></h5>
                                                            <div className="border d-flex flex-wrap  mx-0 px-0 pt-3" style={{ gap: "5px" }} >
                                                                <div className=" border mb-3" style={{ height: 250, width: 228 }}>
                                                                    <ResponsiveContainer width="100%" height="92%">
                                                                        <LineChart
                                                                            data={insightsPatientTemp?.map((cur) => ({ ...cur, temperature: parseFloat(parseFloat(cur?.temperature).toFixed(2)), }))}
                                                                            margin={{
                                                                                top: 10,
                                                                                right: 20,
                                                                                left: -20,
                                                                                bottom: 5
                                                                            }}
                                                                        >
                                                                            <CartesianGrid strokeDasharray="3 3" />
                                                                            <XAxis dataKey="recordDate" />
                                                                            <YAxis />
                                                                            <Tooltip
                                                                                formatter={(value) => `${value}°`}
                                                                                labelFormatter={(label) => `Date: ${label}`}
                                                                            />
                                                                            <Legend />
                                                                            <Line
                                                                                type="monotone"
                                                                                dataKey="temperature"
                                                                                stroke="#8884d8"
                                                                                activeDot={{ r: 8 }}
                                                                            />
                                                                        </LineChart>
                                                                    </ResponsiveContainer>

                                                                    <div className="border-top text-center">
                                                                        <span>Temp</span>
                                                                    </div>

                                                                </div>
                                                                <div className="  border mb-3" style={{ height: 250, width: 228 }}>
                                                                    <ResponsiveContainer width="100%" height="92%" >
                                                                        <LineChart

                                                                            data={insightsPatientBp?.map((cur) => ({ ...cur, sys: Number(cur?.sys), dia: Number(cur?.dia), pulse: Number(cur?.pulse) }))}
                                                                            margin={{
                                                                                top: 10,
                                                                                right: 20,
                                                                                left: -20,
                                                                                bottom: 5,
                                                                            }}
                                                                        >
                                                                            <CartesianGrid strokeDasharray="3 3" />
                                                                            <XAxis dataKey="recordDate" />
                                                                            <YAxis />
                                                                            <Tooltip />
                                                                            <Legend />
                                                                            <Line type="monotone" dataKey="sys" stroke="#8884d8" activeDot={{ r: 8 }} />
                                                                            <Line type="monotone" dataKey="dia" stroke="#82ca9d" />
                                                                            <Line type="monotone" dataKey="pulse" stroke="red" />
                                                                        </LineChart>
                                                                    </ResponsiveContainer>
                                                                    <div className="border-top text-center">
                                                                        <span>BP</span>
                                                                    </div>
                                                                </div>
                                                                <div className="  border mb-3" style={{ height: 250, width: 229 }}>
                                                                    <ResponsiveContainer width="100%" height="92%" >
                                                                        <LineChart
                                                                            data={insightsPatientBMI?.map((cur) => ({ ...cur, bmi: parseFloat(parseFloat(cur?.bmi).toFixed(2)), }))}
                                                                            margin={{
                                                                                top: 10,
                                                                                right: 20,
                                                                                left: -20,
                                                                                bottom: 5,
                                                                            }}
                                                                        >
                                                                            <CartesianGrid strokeDasharray="3 3" />
                                                                            <XAxis dataKey="recordDate" />
                                                                            <YAxis />
                                                                            <Tooltip />
                                                                            <Legend />
                                                                            <Line type="monotone" dataKey="bmi" stroke="#8884d8" activeDot={{ r: 8 }} />
                                                                        </LineChart>
                                                                    </ResponsiveContainer>
                                                                    <div className="border-top text-center">
                                                                        <span>BMI</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </>

                                                }

                                                <div className="d-flex justify-content-end flex-column align-items-end py-3 checkout_slip_footer">
                                                    <h4 >{doctorName}</h4>
                                                    <h5 className="mb-1" >{doctorDegrees}</h5>
                                                    <img src={base64Image?.Signature} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                }
                            </div>
                        }
                        {/* apptDetails?.prescriptionNumber */}
                        {
                            tap === 3 && <div className='p-0 pt-2 text_box_height'>

                                {!apptDetails?.prescriptionNumber ? <div className="col-sm-12 mt-3 text-center " > <NoRecordFound /></div> :
                                    <div className="row mx-0 px-0">
                                        <div className="col-3 ms-auto d-flex justify-content-end pe-0 mb-2">
                                            <CustomButton onClick={handlePrint} variant="contained">print</CustomButton>
                                        </div>
                                        <div className=" tbl-border p-0 mx-0" ref={componentRef}>
                                            <div className="m-0 ps-3">
                                                <h1 className="rx p-0 m-0">Rx</h1>
                                            </div>
                                            <div className="d-flex justify-content-between p-4">
                                                <div className="col-lg-4">
                                                    <div className="botm-border">
                                                        <p className="p-0 m-0 mb-1">
                                                            <b>Patient Name :</b> <span> {(ePrescriptionList?.[0]?.patientFirstName ? ePrescriptionList?.[0]?.patientFirstName : "") + " " + (ePrescriptionList?.[0]?.patientLastName ? ePrescriptionList?.[0]?.patientLastName : '')}</span>
                                                        </p>
                                                    </div>
                                                    <div className="botm-border mt-2">
                                                        <p className="p-0 m-0 mb-1"><b>Age :</b> <span> {ePrescriptionList?.[0]?.age} y</span></p>
                                                    </div>
                                                    <div className="botm-border mt-2">
                                                        <p className="p-0 m-0 mb-1"><b>Gender :</b> <span> {ePrescriptionList?.[0]?.gender}</span></p>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="botm-border">
                                                        <p className="p-0 m-0 mb-1">
                                                            <b>Prescription Number :</b> <span> {ePrescriptionList?.[0]?.prescriptionNumber}</span>
                                                        </p>
                                                    </div>
                                                    <div className="botm-border mt-2">
                                                        <p className="p-0 m-0 mb-1"><b>Date :</b> <span> {moment(ePrescriptionList?.[0]?.startDate).format("DD/MM/YYYY")}</span></p>
                                                    </div>
                                                </div>
                                                <div className="col-lg-1"></div>
                                            </div>
                                            <div className="p-4 " style={{ height: "400px", overflow: "auto", width: "100%" }}>
                                                <table className="table table-bordered tbl-border bootstrap_table_responsive">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Medicine</th>
                                                            <th >Medicine type</th>
                                                            <th>Strength</th>
                                                            <th>Standard</th>
                                                            <th>Duration</th>
                                                            <th>Dosage Instructions</th>
                                                            <th>Quantity</th>
                                                            <th>Notes</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            ePrescriptionList?.map((item, index) => {
                                                                return <tr>
                                                                    <th>{index + 1}</th>
                                                                    <td>{item?.medicineName}</td>
                                                                    <td>{item?.medicineType}</td>
                                                                    <td>{item?.doseAmount + item?.doseType}</td>
                                                                    {/* <td>{` ${item?.medicineIntakeType === "STANDARD" ? `${item?.morningMedCount}-${item?.afternoonMedCount}-${item?.nightMedCount}` : `Every ${item?.medicineIntakeDurationAmount + item?.customMedCountTimeFrame}`} `}</td> */}
                                                                    <td>{Dosage(item)}</td>
                                                                    <td>{item?.medicineIntakeDurationAmount + " " + item?.medicineIntakeDurationType}</td>
                                                                    <td> {item?.medicineIntakeTime !== "CUSTOM" ? item?.medicineIntakeTime : item?.medicineIntakeCustomTime}</td>
                                                                    <td>{item?.medicineIntakeAmount}</td>
                                                                    <td>{item?.notes ? item?.notes : "N/A"}</td>
                                                                </tr>

                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
        {/*delete patient  */}
        < Modal show={deletePatientmodal} onHide={() => setDeletePatientmodal(false)} centered >
            <Modal.Body>
                <div className="modal-body text-center">
                    <i className="fa-solid fa-trash-can all_icons_color mb-2" ></i>
                    <p className="mb-0">Are you sure? </p>
                    <p >You want to delete this patient</p>
                    <CustomButton variant="contained" className="me-3" onClick={() => deletePatientfun("YES", deletePatientdata)} > Yes</CustomButton>
                    <CustomButton variant="outlined" onClick={() => deletePatientfun("NO")} > No</CustomButton>
                </div>
            </Modal.Body>
        </ Modal>
        {/* add patient */}
        <Modal show={addpatientModal} onHide={() => {
            setAddpatientModal(false)
            setValue("2")
        }} centered >
            <Modal.Body>
                <div className="modal-body adddetail">
                    <div className="text-center">
                        <h4 className="modal-title mb-3">Add Patient</h4>
                    </div>

                    <div className="row px-0 mx-0 d-flex justify-content-start mb-2 SelectMultiple">
                        <div className="col-12 px-0 mx-0">
                            <div className="row shadow  ">
                                <div className="col-10 px-0">
                                    <input type="text" onChange={(e) => setAddPatientValue(e?.target?.value)} className='w-100 search' placeholder='Search...' />
                                </div>
                                <div className="col-2 incon_search "><AiOutlineSearch /></div>
                            </div>
                            <div className="row select_box  mt-2">
                                <div className="col-12">
                                    {
                                        allpatientList?.filter((filters, ins) => (filters?.firstName?.toLowerCase() || filters?.lastName?.toLowerCase())?.includes(AddPatientValue?.toLowerCase()))?.map((cur, index) => {
                                            return <React.Fragment key={index}>
                                                <div className="row country_list px-2  py-2 my-2 shadow-sm">
                                                    <div className="form-check  ">
                                                        <input className="form-check-input" onClick={() => addpatientfun(cur?.id)} value={cur?.id} type="radio" name="flexRadioDefault" id={cur?.id} />
                                                        <label className="form-check-label" htmlFor={cur?.id}>
                                                            {(cur?.firstName ? cur?.firstName : "") + " " + (cur?.lastName ? cur?.lastName : '')}
                                                        </label>
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal >
        <CancelAppointment modalCancel={modalCancel} clossOffcanvas={clossOffcanvas} cancelAppointment={cancelAppointment} CustomButton={CustomButton} />
        <RescheduleAppointment clossOffcanvas={clossOffcanvas} modalReschdule={modalReschdule} apptDetails={apptDetails} userdata={userdata}
            moment={moment} appointmentReschedule={appointmentReschedule} TimeslotList={TimeslotList} SlotLodaer={SlotLodaer}
            isActiveSlot={isActiveSlot} setIsactiveSlot={setIsactiveSlot} CustomButton={CustomButton} />
    </>;
};

export default AppointmentDetails;
